<template>
  <div>
    <div class="card shadow mb-4">
      <div class="card-header py-3">
        <span class="m-0 font-weight-bold text-primary">User List</span>
        <button
          class="pull-right btn btn-primary"
          @click="add_user_product_model = !add_user_product_model"
        >
          <i class="fa fa-plus"></i>
        </button>
      </div>
      <b-modal v-model="add_user_product_model" title="Add User" hide-footer="">
        <div v-if="addUserLoading">
          <div class="col-md-12 text-center">
            <sweetalert-icon :icon="loadingType" />
          </div>
          <div class="col-md-12 text-center">
            <h3 class="text-center">{{ loadingMessage }}</h3>
          </div>
        </div>
        <b-form v-on:submit.prevent="addUser" v-if="!addUserLoading">
          <b-form-group label="Select Role:">
            <b-form-select
              v-model="newUser.roleId"
              required
              class="form-control"
              :options="roleList"
            >
            </b-form-select>
          </b-form-group>
          <b-form-group label="Name">
            <b-form-input
              v-model="newUser.name"
              type="text"
              required
              class="form-control"
              placeholder="Enter User Name"
            ></b-form-input>
          </b-form-group>
          <b-form-group label="Email Id:">
            <b-form-input
              v-model="newUser.email"
              type="email"
              required
              class="form-control"
              placeholder="Enter Email Address"
            ></b-form-input>
          </b-form-group>
          <b-form-group label="Phone No:">
            <b-form-input
              v-model="newUser.number"
              type="number"
              required
              class="form-control"
              placeholder="Enter Phone Number"
            ></b-form-input>
          </b-form-group>
          <b-form-group label="Address:">
            <b-form-textarea
              v-model="newUser.address"
              placeholder="Enter User Address"
              rows="3"
              max-rows="6"
            ></b-form-textarea>
          </b-form-group>
          <button type="submit" class="btn btn-success btn-lg">Save</button>
        </b-form>
      </b-modal>
      <div class="card-body">
        <b-container fluid>
          <b-row>
            <b-col sm="4" lg="3" md="4">
              <b-form-group
                label="Filter"
                label-cols-sm="3"
                label-align-sm="right"
                label-size="sm"
                label-for="filterInput"
                class="mb-0"
              >
                <b-input-group size="sm">
                  <b-form-input
                    v-model="filter"
                    type="search"
                    id="filterInput"
                    placeholder="Type to Search"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button :disabled="!filter" @click="filter = ''"
                      >Clear</b-button
                    >
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col
              offset-md="4"
              offset-sm="4"
              offset-lg="6"
              sm="4"
              md="4"
              lg="3"
              class="my-1"
            >
              <b-form-group
                label="Per page"
                label-cols-sm="6"
                label-cols-md="4"
                label-cols-lg="3"
                label-align-sm="right"
                label-size="sm"
                label-for="perPageSelect"
                class="mb-0"
              >
                <b-form-select
                  v-model="perPage"
                  id="perPageSelect"
                  size="sm"
                  :options="pageOptions"
                ></b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-table
            show-empty
            small
            stacked="md"
            :busy.sync="loading"
            :items="items"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :filterIncludedFields="filterOn"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            @filtered="onFiltered"
          >
            <template v-slot:table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </template>
            <template v-slot:cell(status)="data">
              <b-badge variant="success" v-if="data.item.status == true"
                >Active</b-badge
              >
              <b-badge variant="danger" v-else>Deactive</b-badge>
            </template>
            <template v-slot:cell(action)="data">
              <span v-if="data.item.status == false">
                <button
                  class="btn btn-sm btn-success"
                  @click="Approve(data.item, 'true')"
                  v-b-tooltip.hover
                  title="Activate"
                >
                  <i class="fa fa-check"></i>
                </button>
              </span>
              <span v-else-if="data.item.status == true" class="mr-1">
                <button
                  class="btn btn-sm btn-danger"
                  @click="Approve(data.item, 'false')"
                  v-b-tooltip.hover
                  title="Deactivate"
                >
                  <i class="fa fa-times"></i>
                </button>
              </span>
            </template>
          </b-table>
          <b-row>
            <b-col sm="4" md="4" lg="4" class="my-1">
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="fill"
                size="sm"
                class="my-0"
              ></b-pagination>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
  </div>
</template>

<script>
// import Vue from "vue";
import { mapGetters } from "vuex";
import { dbFs, checkUser } from "@/modules/database";
import { vendorUserRegistration } from "@/modules/auth";
export default {
  data() {
    return {
      //datatable
      fields: [
        {
          key: "sr",
          label: "#",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "name",
          label: "Name",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "email",
          label: "Email",
          sortable: false,
          class: "text-center"
        },
        {
          key: "number",
          label: "Number",
          sortable: false,
          class: "text-center"
        },
        {
          key: "vendorname",
          label: "Vendor Name",
          sortable: true,
          class: "text-center"
        },
        {
          key: "role",
          label: "Role",
          sortable: true,
          class: "text-center"
        },
        {
          key: "permission",
          label: "Permission",
          sortable: true,
          class: "text-center"
        },
        {
          key: "status",
          label: "Status",
          sortable: true,
          class: "text-center"
        },
        {
          key: "action",
          label: "Action",
          // sortable: true,
          class: "text-center"
        }
      ],
      items: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      //datatable end
      loading: false,
      dataTable: null,
      addUserLoading: false,
      add_user_product_model: false,
      roles: [],
      VendorUsers: [],
      vendor: [],
      loadingType: "loading",
      loadingMessage: "Uploading",
      roleList: [],
      newUser: {
        address: "",
        email: "",
        name: "",
        number: null,
        roleId: null,
        status: false,
        vendorId: ""
      }
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser"
    }),
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    }
  },
  mounted() {
    this.setupFirebaseReading();
    this.getRoles();
  },
  methods: {
    setupFirebaseReading: function() {
      this.loading = true;
      this.$bind("VendorUsers", dbFs.collection("user"));
      this.$bind("vendor", dbFs.collection("vendor"));
      this.$bind("roles", dbFs.collection("userRoles"))
        .then(() => {
          this.MapforTable();
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    MapforTable() {
      let index = 0;
      let vendorName = "Admin";
      this.VendorUsers.forEach(user => {
        if (this.getRoleById(user.roleId, "type") == "vendor") {
          vendorName = this.getVendorById(user.vendorId, "name");
        }
        this.items.push({
          id: user.id,
          sr: ++index,
          name: user.name,
          email: user.email,
          number: user.number,
          vendorname: vendorName,
          role: this.getRoleById(user.roleId, "type"),
          permission: this.getRoleById(user.roleId, "name"),
          status: user.status
        });
      });
    },
    getRoles() {
      this.loading = true;
      let role = [];
      role.push({
        value: null,
        text: "Select Role"
      });
      this.getLessThan500KOrMoreThan1M5()
        .then(querySnapshot => {
          querySnapshot.forEach(function(doc) {
            role.push({
              value: doc.id,
              text: doc.data().name
            });
          });
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.roleList = role;
          this.loading = false;
        });
    },
    getRoleById(id, dataType) {
      let roles = {
        name: "Role Not Found",
        type: "not Found"
      };
      for (const cusKey of Object.keys(this.roles)) {
        const category = this.roles[cusKey];
        if (id == category.id) {
          roles = category;
        }
      }
      if (dataType == "name") {
        return roles.name;
      }
      if (dataType == "type") {
        return roles.type;
      }
    },
    getVendorById(id, dataType) {
      let roles = {
        shopDetails: {
          name: "not Found"
        }
      };
      for (const cusKey of Object.keys(this.vendor)) {
        const category = this.vendor[cusKey];
        if (id == category.id) {
          roles = category;
        }
      }
      if (dataType == "name") {
        return roles.shopDetails.name;
      }
    },
    addUser() {
      this.addUserLoading = true;
      this.loadingMessage = "Adding User";
      checkUser(this.newUser.email)
        .then(() => {
          console.log("test");
          vendorUserRegistration(
            this.newUser.email,
            Math.random()
              .toString(36)
              .slice(2),
            this.newUser
          ).then(() => {
            this.loadingType = "success";
            this.loadingMessage = "User Added Successfull";
          });
        })
        .catch(error => {
          console.log(error);
          this.loadingType = "error";
          this.loadingMessage = error;
        })
        .finally(() => {
          setTimeout(() => {
            this.add_user_product_model = false;
            this.addUserLoading = false;
            this.newUser = {
              address: "",
              email: "",
              name: "",
              number: null,
              roleId: null,
              status: false,
              vendorId: this.$route.params.vendorId
            };
          }, 3000);
        });
    },
    Approve(user, type) {
      let status = false;
      // let newarry = user.status = status;
      // let index = --user.sr;
      // Vue.set(this.items, index, newarry);
      // this.items[index].status = status;
      if (type == "true") {
        status = true;
      }
      let update = {
        status: status
      };
      dbFs
        .collection("user")
        .doc(user.id)
        .set(update, { merge: true })
        .then(() => {});
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    }
  }
};
</script>

<style scoped></style>
